module.exports = __webpack_public_path__ + "static/media/SFCompactDisplay-Light.97f4a558.ttf";